export default __webpack_public_path__ + "static/drilldown-bar-table-7db22865eab5ad58096548a4f3fb8fdf.mp4";